type IssueKey = string;

const CLOSED = 'CLOSED' as const;
const SHOWING_ISSUE = 'SHOWING_ISSUE' as const;

export const SidebarStatuses = {
	CLOSED,
	SHOWING_ISSUE,
} as const;

type Closed = {
	status: typeof CLOSED;
};

type ShowingIssue = {
	status: typeof SHOWING_ISSUE;
	issueKey: IssueKey;
};

export type SidebarState = Closed | ShowingIssue;
export type SidebarStoreState = {
	state: SidebarState;
};
